<template>
  <v-sheet class="pt-6 pb-10 px-10">
    <div class="text-body-1 font-weight-bold mb-8">Other options</div>
    <v-row>
      <v-col v-for="option in options" :key="option.id" class="text-center">
        <v-card @click="$emit('view', 'referral')" class="pa-6" color="grey lighten-3" elevation="0">
          <img :src="option.img" alt="" style="width: 100px">
<!--          <div class="mt-2">{{ option.name }}</div>-->
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "MoreAddProductOptions",
  data() {
    return {
      options: [
        { id: 'jumia', name: 'Jumia', img: '/img/logos/jumia.svg', },
        { id: 'konga', name: 'Konga', img: '/img/logos/konga.png', },
        { id: 'paystack', name: 'Paystack', img: '/img/logos/paystack.png', },
        { id: 'flutterwave', name: 'Flutterwave', img: '/img/logos/flutterwave.svg', },
        { id: 'aliexpress', name: 'Aliexpress', img: '/img/logos/aliexpress.svg', },
        { id: 'olist', name: 'OList', img: '/img/logos/olist.png', },
        { id: 'amazon', name: 'Amazon', img: '/img/logos/amazon.png', },
      ]
    }
  }
}
</script>
